import Vue from "vue";
import VueRouter, {RouteConfig} from "vue-router";
import Login from "@/views/login.vue";
import TPLogin from "@/views/tp-login.vue";
import Home from "@/views/home.vue";
import ViewMaterial from "@/views/view-material.vue";
import ViewBrandManual from "@/views/view-brand-manual.vue";
import ManageUsers from "@/views/management/users.vue";
import ManageMaterials from "@/views/management/materials.vue";
import ManageMaterial from "@/views/management/material.vue";
import ManageBrandManuals from "@/views/management/brands.vue";
import TrainingCompletion from "@/views/training-completion.vue";
import PasswordReset from "@/views/password-reset.vue";
import ManageImportantLinks from "@/views/management/important-links.vue";
import SalesReports from "@/views/management/sales.vue";
import Settings from "@/views/management/settings.vue";
import Alerts from "@/views/management/alerts.vue";
import SalesApproval from "@/views/management/sales-approval.vue";
import ViewSales from "@/views/management/sales-view.vue";
import TPAnalytics from "@/views/management/tp-analytics.vue";
import TPTimeline from "@/views/management/tp-timeline.vue";
import TPCompare from "@/views/management/tp-compare.vue";
import TPVerification from "@/views/management/tp-verification.vue";
import TPCatering from "@/views/management/tp-catering.vue";
import TPSales from "@/views/management/tp-sales.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "home",
        component: Home
    },
    {
        name: "authorize",
        path: "/authorize",
        component: Login
    },
    {
        name: "tp-Login",
        path: "/tp-login",
        component: TPLogin
    },
    {
        name: "view-material",
        path: "/material/:id",
        component: ViewMaterial
    },
    {
        name: "brand-manual",
        path: "/brand-manual/:id",
        component: ViewBrandManual
    },
    {
        name: "manage-users",
        path: "/manage/users",
        component: ManageUsers
    },
    {
        name: "sales-approval",
        path: "/manage/salesapproval",
        component: SalesApproval,
    },
    {
        name: "manage-materials",
        path: "/manage/materials",
        component: ManageMaterials,
    },
    {
        name: "add-material",
        path: "/manage/add-material",
        component: ManageMaterial,
    },
    {
        name: "edit-material",
        path: "/manage/edit-material/:id",
        component: ManageMaterial,
    },
    {
        name: "manage-brand-manuals",
        path: "/manage/brand-manuals",
        component: ManageBrandManuals,
    },
    {
        name: "manage-important-links",
        path: "/manage/important-links",
        component: ManageImportantLinks,
    },
    {
        name: "report-training-completion",
        path: "/report/training-completion",
        component: TrainingCompletion,
    },
    {
        name: "password-reset",
        path: "/password-reset",
        component: PasswordReset,
    },
    {
        name: "sales-reports",
        path: "/manage/salesreports",
        component: SalesReports,
    },
    {
        name: "sales-view",
        path: "/manage/sales-view",
        component: ViewSales,
    },
    {
        name: "tp-analytics",
        path: "/manage/tp-analytics",
        component: TPAnalytics,
    },
    {
        name: "tp-sales",
        path: "/manage/tp-sales",
        component: TPSales,
    },
    {
        name: "tp-sales",
        path: "/manage/touch-point",
        component: TPSales,
    },
    {
        name: "tp-timeline",
        path: "/manage/tp-timeline",
        component: TPTimeline,
    },
    {
        name: "tp-compare",
        path: "/manage/tp-compare",
        component: TPCompare,
    },
    {
        name: "tp-verification",
        path: "/manage/tp-verification",
        component: TPVerification,
    },
    {
        name: "tp-catering",
        path: "/manage/tp-catering",
        component: TPCatering,
    },
    {
        name: "settings",
        path: "/manage/settings",
        component: Settings,
    },
    {
        name: "alerts",
        path: "/manage/alerts",
        component: Alerts,
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
